<h1 mat-dialog-title class="dialog-header">{{ "Scope" | translate }}: {{ data.tagName }}</h1>

<mat-dialog-content class="mat-typography">
  <p class="hint">{{ "ScopeExplanation" | translate }}</p>
  <div class="w-full flex justify-between gap-8 mb-4">
    <mat-form-field class="w-full h-20 max-h-20">
      <mat-label>{{ "Clients" | translate }}</mat-label>
      <mat-select>
        @for (client of allClients; track $index) {
        <mat-option [value]="client.id" (click)="appendClient(client)">{{
          client.company.name
        }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="w-full flex flex-wrap tag-container">
      @for (client of selectedClients; track $index) {
      <span class="tag"><span class="brightness-50 saturate-200">{{client.company.name}}</span><span style="margin: 0 -.5rem 0 .75rem" class="brightness-50 saturate-200 cursor-pointer" (click)="removeClient(client)">x</span></span>
      }
    </div>
  </div>
  <div class="w-full flex justify-between gap-8 mb-4">
    <mat-form-field class="w-full h-20 max-h-20">
      <mat-label>{{ "Customers" | translate }}</mat-label>
      <mat-select>
        @for (customer of allCustomers; track $index) {
        <mat-option [value]="customer.id" (click)="appendCustomer(customer)">{{
          customer.company.name
        }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="w-full flex flex-wrap tag-container">
      @for (customer of selectedCustomers; track $index) {
      <span class="tag"><span class="brightness-50 saturate-200">{{customer.company.name}}</span><span style="margin: 0 -.5rem 0 .75rem" class="brightness-50 saturate-200 cursor-pointer" (click)="removeCustomer(customer)">x</span></span>
      }
    </div>
  </div>

  <div class="float-right">
    <button mat-button mat-dialog-close>{{ "Cancel" | translate }}</button>
    <button mat-flat-button color="primary" class="ml-2" (click)="save()">{{ "Save" | translate }}</button>
  </div>
</mat-dialog-content>
